<template>
  <div>
    <v-btn block class="no-text-transform" :color="this.$route.params.id == id ? 'green lighten-4' : 'white'" style="height: 60px;" @click="goToBenefit(id)">
      <span style="white-space: normal;">{{name}}</span>
    </v-btn>
  </div>
</template>

<script>
import { mapActions} from "vuex";
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions("benefits",["fetchBenefit"]),
    goToBenefit(id) {
    this.fetchBenefit({id: id, full_legal_number: localStorage.getItem("view_as")});
     this.$router.push({
        name: "benefit-show",
        params: { id: id }
      });
    }
  },
};
</script>

<style>
</style>